angular.module('impactx.cancelcondition').controller('CancelConditionListController', [
    'selectedListItems',
    CancelConditionListCtrl
]);

function CancelConditionListCtrl(selectedListItems) {

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'CancelCondition'
        }
    ];
    this.meta = {
        rowTemplate: 'modules/cancelcondition/templates/cancelconditionlist.row.tmpl.html',
        buttonDefinition: buttonDefinition,
        isSelectAble: true,
        endpoint: '/cancelcondition/list',
        ctrl: this,
        id: "cancelconditionlist",
        mainAction: {id: "new", link: "#/cancelcondition/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "cancelcondition/" + selectedListItems.getFirstSelectedId();

    }
}